import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import { withCreateBook } from "src/modules/book/operations";
import { compose } from "src/helpers";

import CreateView from "./component";

const Create = (props) => {
    const { createBook } = props;
    const router = useRouter();

    const onFinish = async (values: any) => {
        await createBook(values);
        router.push("/book");
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return <CreateView onFinish={onFinish} onFinishFailed={onFinishFailed} />;
};

export default compose(withCreateBook)(Create);
